/**
 * 
 */
class WMUWCAccount {

	/**
	 * 
	 * @type String
	 */
	actionLogin = '';

	/**
	 * 
	 * @type String
	 */
	actionLogout = '';

	/**
	 * 
	 * @type String
	 */
	actionLostPassword = '';

	/**
	 * 
	 * @type String
	 */
	ajaxUrl = '';

	/**
	 * 
	 * @type Boolean
	 */
	debug = false;

	/**
	 * 
	 * @type String
	 */
	formLoginSelector = '#wmuwc-form-login';

	/**
	 * 
	 * @type String
	 */
	formLostPasswordSelector = '#wmuwc-form-lost-password';

	/**
	 * 
	 * @type Boolean
	 */
	isCalling = false;

	/**
	 * 
	 * @type String
	 */
	loginButtonSelector = '.login-button';

	/**
	 * 
	 * @type String
	 */
	logoutButtonSelector = '.logout-button';

	/**
	 * 
	 * @type String
	 */
	lostPasswordButtonSelector = '.lost-password-button';

	/**
	 * 
	 * @type WMUWCPopin
	 */
	popin = null;

	/**
	 * 
	 * @type String
	 */
	popinId = 'wmuwc-account-popin';

	/**
	 * 
	 * @type String
	 */
	nonce = '';

	/**
	 * 
	 * @type String
	 */
	status = '';

	/**
	 * 
	 * @param {Object} args Expected properties : actionLogin (ajax action name), actionLogout (ajax action name), ajaxUrl (wordpress ajax URL) and nonce (nonce value)
	 */
	constructor( args )
	{
		this.actionLogin = args.actionLogin;
		this.actionLogout = args.actionLogout;
		this.actionLostPassword = args.actionLostPassword;
		this.ajaxUrl = args.ajaxUrl;
		this.nonce = args.nonce;
		this.debug = (
			args.debug == "1"
			|| args.debug == "true"
			|| args.debug == true
			|| args.debug == 1
			) ? true : false;

		this.init();
	}

	/**
	 * 
	 */
	init()
	{
		this.onFormLoginSubmit = this.onFormLoginSubmit.bind( this );
		this.onFormLostPasswordSubmit = this.onFormLostPasswordSubmit.bind( this );
		this.onLoginClick = this.onLoginClick.bind( this );
		this.onLogoutClick = this.onLogoutClick.bind( this );
		this.onLostPasswordClick = this.onLostPasswordClick.bind( this );
	}

	/**
	 * 
	 * @param {HTMLElement} contextElement 
	 */
	initLoginButtons( contextElement = null )
	{
		if ( null === contextElement )
		{
			contextElement = document.body;
		}

		contextElement.querySelectorAll( this.loginButtonSelector ).forEach( ( element ) =>
		{
			if ( ! element.wmuwcAccount )
			{
				element.addEventListener( 'click', this.onLoginClick );
				element.wmuwcAccount = this;
			}
		} );
	}

	/**
	 * 
	 * @param {HTMLElement} contextElement 
	 */
	initLogoutButtons( contextElement = null )
	{
		if ( null === contextElement )
		{
			contextElement = document.body;
		}

		contextElement.querySelectorAll( this.logoutButtonSelector ).forEach( ( element ) =>
		{
			if ( ! element.wmuwcAccount )
			{
				element.addEventListener( 'click', this.onLogoutClick );
				element.wmuwcAccount = this;
			}
		} );
	}

	/**
	 * 
	 * @param {HTMLElement} contextElement 
	 */
	initLostPasswordButtons( contextElement = null )
	{
		if ( null === contextElement )
		{
			contextElement = document.body;
		}

		contextElement.querySelectorAll( this.lostPasswordButtonSelector ).forEach( ( element ) =>
		{
			if ( ! element.wmuwcAccount )
			{
				element.addEventListener( 'click', this.onLostPasswordClick );
				element.wmuwcAccount = this;
			}
		} );
	}

	/**
	 * 
	 * @param {HTMLElement} contextElement 
	 */
	initFormLogin( contextElement = null )
	{
		if ( null === contextElement )
		{
			contextElement = document.body;
		}

		contextElement.querySelectorAll( this.formLoginSelector ).forEach( ( element ) =>
		{
			if ( ! element.wmuwcAccount )
			{
				element.addEventListener( 'submit', this.onFormLoginSubmit );
				element.wmuwcAccount = this;
			}
		} );
	}

	/**
	 * 
	 * @param {HTMLElement} contextElement 
	 */
	initFormLostPassword( contextElement = null )
	{
		if ( null === contextElement )
		{
			contextElement = document.body;
		}

		contextElement.querySelectorAll( this.formLostPasswordSelector ).forEach( ( element ) =>
		{
			if ( ! element.wmuwcAccount )
			{
				element.addEventListener( 'submit', this.onFormLostPasswordSubmit );
				element.wmuwcAccount = this;
			}
		} );
	}

	/**
	 * 
	 */
	login( formData = null)
	{
		if ( true === this.isCalling )
		{
			/**
			 * @todo Faire une queue d'appel dans ce cas ?
			 */
			return;
		}

		if ( null === this.popin )
		{
			this.popin = wmuwcPopin.manager.get( this.popinId );
		}

		this.popin.open();
		this.popin.startLoading();

		window.dispatchEvent( new CustomEvent( 'wmuwc/login' ) );

		if ( null === formData ) formData = new FormData();
		formData.append( 'action', this.actionLogin );
		formData.append( '_ajax_nonce', this.nonce );

		if ( this.debug )
		{
			console.log( 'Account login data', formData );
		}

		const fetchInit = {
			method: 'POST',
			cache: 'no-cache',
			body: formData,
		};

		fetch( this.ajaxUrl, fetchInit )
			.then( ( response ) => response.json() )
			.then( ( data ) =>
			{
				if ( true === data.success )
				{
					if ( data.data && data.data.status )
					{
						this.status = data.data.status;
					}

					if ( data.data && data.data.content )
					{
						this.setPopinContent( data.data.content );
					}
				}
				else
				{

				}

				this.loginComplete();
			} )
			.catch( ( error ) =>
			{
				console.error( error );
				this.loginComplete();
			} );
		
		this.isCalling = true;
	}

	/**
	 * 
	 */
	loginComplete()
	{
		this.isCalling = false;
		window.dispatchEvent( new CustomEvent( 'wmuwc/loginComplete' ) );
		this.popin.endLoading();
	}

	/**
	 * 
	 */
	logout()
	{
		if ( null === this.popin )
		{
			this.popin = wmuwcPopin.manager.get( this.popinId );
		}

		this.popin.open();
		this.popin.startLoading();

		window.dispatchEvent( new CustomEvent( 'wmuwc/logout' ) );

		const formData = new FormData();
		formData.append( 'action', this.actionLogout );
		formData.append( '_ajax_nonce', this.nonce );

		const fetchInit = {
			method: 'POST',
			cache: 'no-cache',
			body: formData,
		};

		fetch( this.ajaxUrl, fetchInit )
			.then( ( response ) => response.json() )
			.then( ( data ) =>
			{
				if ( true === data.success )
				{
					if ( data.data && data.data.status )
					{
						this.status = data.data.status;
					}

					if ( data.data && data.data.content )
					{
						this.setPopinContent( data.data.content );
					}
				}
				else
				{
					console.error( data );
					this.status = 'logout-error';
				}

				this.logoutComplete();
			} )
			.catch( ( error ) =>
			{
				console.error( error );
				this.status = 'logout-error';
				this.logoutComplete();
			} );
	}

	/**
	 * 
	 */
	logoutComplete()
	{
		this.isCalling = false;
		window.dispatchEvent( new CustomEvent( 'wmuwc/logoutComplete' ) );
		this.popin.endLoading();
	}

	/**
	 * 
	 */
	lostPassword( formData = null )
	{
		if ( true === this.isCalling )
		{
			/**
			 * @todo Faire une queue d'appel dans ce cas ?
			 */
			return;
		}

		if ( null === this.popin )
		{
			this.popin = wmuwcPopin.manager.get( this.popinId );
		}

		this.popin.open();
		this.popin.startLoading();

		window.dispatchEvent( new CustomEvent( 'wmuwc/lostPassword' ) );

		if ( null === formData ) formData = new FormData();
		formData.append( 'action', this.actionLostPassword );
		formData.append( '_ajax_nonce', this.nonce );

		const fetchInit = {
			method: 'POST',
			cache: 'no-cache',
			body: formData,
		};

		fetch( this.ajaxUrl, fetchInit )
			.then( ( response ) => response.json() )
			.then( ( data ) =>
			{
				if ( true === data.success )
				{
					if ( data.data && data.data.status )
					{
						this.status = data.data.status;
					}

					if ( data.data && data.data.content )
					{
						this.setPopinContent( data.data.content );
					}
				}
				else
				{

				}

				this.lostPasswordComplete();
			} )
			.catch( ( error ) =>
			{
				console.error( error );
				this.lostPasswordComplete();
			} );
		
		this.isCalling = true;
	}

	/**
	 * 
	 */
	lostPasswordComplete()
	{
		this.isCalling = false;
		window.dispatchEvent( new CustomEvent( 'wmuwc/lostPasswordComplete' ) );
		this.popin.endLoading();
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onFormLoginSubmit( event )
	{
		event.preventDefault();
		this.login( new FormData( event.target ) );
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onFormLostPasswordSubmit( event )
	{
		event.preventDefault();
		this.lostPassword( new FormData( event.target ) );
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onLoginClick( event )
	{
		event.preventDefault();
		this.login();
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onLogoutClick( event )
	{
		event.preventDefault();
		this.logout();
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onLostPasswordClick( event )
	{
		event.preventDefault();
		this.lostPassword();
	}

	/**
	 * 
	 * @param {String} content 
	 */
	setPopinContent( content )
	{
		if ( null === this.popin )
		{
			this.popin = wmuwcPopin.manager.get( this.popinId );
		}

		this.popin.setContent( content );

		switch ( this.status )
		{
			case 'form-login':
			case 'form-login-error':
				this.initFormLogin( this.popin.contentElement );
				this.initLostPasswordButtons( this.popin.contentElement );
			break;

			case 'form-login-success':
			case 'logout-success':
				/**
				 * Système pour éviter de reposter les valeurs de formulaires si on utilisait window.location.reload()
				 */
				let refreshedUrl = window.location.origin +  window.location.pathname;
				let search = '';

				if ( window.location.search )
				{
					let index = 0;
					let newSearch = '?';
					let findReload = false;
					search = window.location.search.substring( 1 );
					search.split( '&' ).forEach( ( searchEntry ) =>
					{
						searchEntry = searchEntry.split( '=' );
						if ( index > 0 ) newSearch += '&';
						if ( searchEntry.length === 1 )
						{
							newSearch += searchEntry[0];
						}
						else
						{
							if ( 'wmuwcReload' === searchEntry[0] )
							{
								findReload = true;
								newSearch += `${searchEntry[0]}=${parseInt( searchEntry[1] ) + 1}`;
							}
							else
							{
								newSearch += `${searchEntry[0]}=${searchEntry[1]}`;
							}
						}
						index++;
					} );

					if ( ! findReload )
					{
						newSearch += '&wmuwcReload=1';
					}

					search = newSearch;
				}
				else
				{
					search = '?wmuwcReload=1';
				}

				window.location.href = refreshedUrl + search;
			break;

			case 'form-lost-password':
			case 'form-lost-password-error':
				this.initFormLostPassword( this.popin.contentElement );
			break;
		}

		window.dispatchEvent( new CustomEvent( 'wmuwc/setAccountPopinContent', {
			detail: {
				content: content,
			}
		} ) );
	}

}

export default WMUWCAccount;